export default __webpack_public_path__ + "static/media/Hydrological_Drought.39a56e59.webp";